var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-reload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.989258 9.99967C0.989258 5.30691 4.80691 1.48926 9.49967 1.48926C11.6532 1.48926 13.6805 2.29985 15.2393 3.73102V2.08301C15.2393 1.75518 15.5052 1.48926 15.833 1.48926C16.1608 1.48926 16.4268 1.75518 16.4268 2.08301V5.24587C16.4268 5.24722 16.4275 5.24833 16.4275 5.24967C16.4275 5.5775 16.1616 5.84342 15.8338 5.84342H12.6663C12.3385 5.84342 12.0726 5.5775 12.0726 5.24967C12.0726 4.92185 12.3385 4.65592 12.6663 4.65592H14.4955C13.1466 3.39227 11.3782 2.67676 9.49967 2.67676C5.4617 2.67676 2.17676 5.9617 2.17676 9.99967C2.17676 14.0376 5.4617 17.3226 9.49967 17.3226C13.5376 17.3226 16.8226 14.0376 16.8226 9.99967C16.8226 9.67184 17.0885 9.40592 17.4163 9.40592C17.7442 9.40592 18.0101 9.67184 18.0101 9.99967C18.0101 14.6924 14.1924 18.5101 9.49967 18.5101C4.80691 18.5101 0.989258 14.6924 0.989258 9.99967Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReload);
export default __webpack_public_path__ + "static/media/arrow-reload.657e49091695084e5df1e3b8dce7045c.svg";
export { ForwardRef as ReactComponent };